var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.559 18L0.5 16.941L7.91075 9.53026C8.05135 9.38961 8.13034 9.19888 8.13034 9.00001C8.13034 8.80113 8.05135 8.6104 7.91075 8.46976L0.51275 1.07326L1.57325 0.0127563L8.96975 7.40926C9.39156 7.83119 9.62852 8.40339 9.62852 9.00001C9.62852 9.59663 9.39156 10.1688 8.96975 10.5908L1.559 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIcon);
export default __webpack_public_path__ + "static/media/white-icon.3d8b89e79f081dc7f1ef2a35837092b9.svg";
export { ForwardRef as ReactComponent };